import moment from 'moment';

const dateFormat = (date, type = 'DD-MM-YYYY') => (date ? moment(date).format(type) : '');
export default dateFormat;
